import { tmrDialogController } from 'tmr/controllers/dialog/dialog'
import templateUrl from './newSessionTransferToZoneDialog.html'
import './newSessionTransferToZoneDialog.scss'

/**
 * Configures dialog Items by Upc (preset `tmrSessionTransferToZone`).
 *
 * @type {ngConfig}
 */
function tmrNewSessionTransferToZoneDialogConfig($mdDialogProvider) {
  'ngInject'
  $mdDialogProvider.addPreset('tmrNewSessionTransferToZone', {
    options: /*@ngInject*/ () => ({
      templateUrl,
      clickOutsideToClose: false,
      fullscreen: true,
      controller: 'tmrNewSessionTransferToZoneDialogController',
      controllerAs: '$ctrl',
      bindToController: true,
      locals: {
        sessionCode: null,
        loggedUser: null,
      },
    }),
  })
}

export { tmrNewSessionTransferToZoneDialogConfig as config }

/**
 * Controller of Dialog {@link tmrNewSessionTransferToZoneDialogConfig tmrNewSessionTransferToZone}.
 *
 * @type {ngController}
 */
export class tmrNewSessionTransferToZoneDialogController extends tmrDialogController {
  constructor($mdDialog, $transitions, Session, Zone, Checklist) {
    'ngInject'
    super($mdDialog, $transitions)
    Object.assign(this, { Session, Zone, Checklist })
  }

  $onInit() {
    super.$onInit()
    this.isCodeValid = true
    this.session = this.Session.create({ code: this.sessionCode })
  }

  onCallBackSession(action) {
    this.$mdDialog.hide(action)
  }

  // abort phase to phase process
  onClickAbort() {
    this.$mdDialog.hide()
  }

  onCancelSession() {
    this.onClickAbort()
  }

  // Checklist methods
  getChecklists(value) {
    return this.Checklist.search({ value }).$promise.then(
      checklists => checklists
    )
  }

  // Zone methods
  getZones(value) {
    return this.Zone.search({ value }).$promise.then(zones =>
      zones.filter(zone => zone.place.id != this.loggedUser.place.id)
    )
  }

  onChangeZone() {}

  // Create Session
  onCreateSession() {
    this.Session.save({
      code: this.sessionCode,
      description: this.description,
      checklist: this.checklist,
      destinationZone: this.zone,
    }).$promise.then(res => this.$mdDialog.hide(res))
  }
}
